import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { onError } from 'apollo-link-error';

import { logoutAction } from '@actions/authActions';
import Env from '@utils/Env';
import App from '@root/App';

const httpLink = createHttpLink({ uri: Env.graphqlApiUrl });

const authLink = setContext((_, { headers }) => {
    // @ts-ignore
    const { token } = App.getState().auth;
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        },
    };
});

const unauthorizedApiRequests: string[] = [
    'login',
    'forgotPassword',
];

const errorLink = onError(({ graphQLErrors, networkError, response, operation, forward }) => {
    console.log({ graphQLErrors, networkError, response, operation, forward });

    if (graphQLErrors) {
        for (const graphQLError of graphQLErrors) {
            if (!graphQLError.extensions || unauthorizedApiRequests.some((request) => operation.operationName === request))  {
                continue;
            }
        }
    }

    if (networkError) {
        console.warn(`[Network error]: ${networkError}`, networkError, operation, forward);
        // TODO: Show error
        // @ts-ignore
        if (networkError && networkError.response && networkError.response.status === 401) {
            // @ts-ignore
            App.dispatch(logoutAction());
        }
    }

    return;
});

export const parseInput = (object: any) => {
        const obj = JSON.parse(JSON.stringify(object));
        let index;
        for (const prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                switch (typeof(obj[prop])){
                    case 'string':
                        index = ['__typename'].indexOf(prop);
                        if (index > -1) {
                            delete obj[prop];
                        }
                        break;
                    case 'object':
                        index = ['__typename'].indexOf(prop);
                        if (index > -1) {
                            delete obj[prop];
                        }else {
                            obj[prop] = parseInput(obj[prop]);
                        }
                        break;
                }
            }
        }
        return obj;
};

export const parseGraphQLError = (graphqlError: Error) => {
    const parts = graphqlError.message.split('error: ');
    if (parts.length > 1) {
        return parts[1];
    } else {
        return 'unknown';
    }
};

const GraphQLClient = new ApolloClient({
    link: authLink.concat(errorLink).concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'network-only',
            errorPolicy: 'ignore',
        },
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        },
    },
});

export default GraphQLClient;



// WEBPACK FOOTER //
// ./src/api/graphql/GraphQLClient.ts